<template>
  <section>
    <div class="max-w-screen-2xl mx-auto px-4 flex flex-wrap py-10 my-6">
      <div class="w-full md:w-2/3 pt-10" v-if="!hidePrices">
        <h2 class="font-secondary text-2xl md:text-3xl mb-2 md:mb-8">
          {{ tr('Prices per person') }}
        </h2>
      </div>

      <div class="w-full flex mx-auto flex-wrap relative mb-4 md:mb-4">
        <div class="w-full py-6 md:py-8 flex flex-wrap relative justify-center">
          <div
            v-for="(pax, index) in groupPrices"
            :key="index"
            class="md:w-1/2 w-full mb-8 2xl:mb-6"
          >
            <h2 class="font-secondary text-xl 2xl:text-xl mb-4" v-if="pax.RoomType">
              <span class="text-primary">{{ tr(pax.RoomType) }}</span>
            </h2>
            <div class="border-5 border-dark shadow-xl p-4 md:p-6 flex flex-wrap justify-center rounded-xl md:mr-8">
              <div class="flex flex-col justify-center items-center">
                <p class="font-secondary text-2xl mb-2" v-if="!hidePrices">{{ getCategoryForPax(pax.PaxName) }}</p>
                <svg width="70" height="16" viewBox="0 0 70 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M50.5875 0L69.1588 10.8708L66.3134 15.9716L50.4742 6.70003L34.9642 15.0621L19.4218 6.6825L2.74625 16L0 10.8425L19.3734 0.0175261L34.9642 8.42325L50.5875 0Z" fill="#F19F00"/>
                </svg>
              </div>
              <div class="flex w-full mt-3 justify-center" v-if="!hidePrices">
                <div class="w-auto text-center pt-2">
                  <span class="uppercase font-primary font-black text-2xl text-primary">
                    {{ Math.round(pax.PriceTotal * currencyRate) }} {{ currency }}
                  </span>
                </div>
              </div>
              <div class="flex w-full mt-6 justify-center">
                <a
                  class="font-light border border-dark bg-white text-md py-2 px-4 w-full hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
                  @click="viewHotels"
                >{{ tr('View') }} {{ getCategoryForPax(pax.PaxName) }} {{ tr('Hotels') }}</a>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="w-full my-10 2xl:my-6">
        <div id="accordion-collapse-group" data-active-classes="text-primary" data-accordion="collapse">
          <div v-if="hotelPainting && hotelPainting.length > 0 && !isQuote">
            <h2 id="accordion-collapse-heading-group-hotels">
              <button
                type="button"
                class="flex items-center bg-white justify-between w-full px-5 py-4 font-medium rtl:text-right text-dark border-t border-b-0 border-gray-200 gap-3"
                @click="toggleHotels"
                :aria-expanded="showHotels"
              >
                <span class="text-lg hover:text-primary font-bold">
                  <svg class="mr-3 inline-block" width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.368123 5.62305L6.60845 9.08631C6.8248 9.20579 7.08636 9.20579 7.30271 9.08631L13.5366 5.62305C14.0274 5.35019 14.0274 4.64462 13.5366 4.37176L7.3011 0.913339C7.08636 0.793861 6.8248 0.793861 6.60845 0.913339L0.368123 4.37176C-0.122708 4.64462 -0.122708 5.35019 0.368123 5.62305Z" fill="#F19F00"/>
                  </svg>
                  {{ tr('Hotels for your trip') }}
                </span>
                <svg :class="{ 'rotate-180': showHotels }" class="w-3 h-3 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                </svg>
              </button>
            </h2>
            <div :class="{ 'hidden': !showHotels }">
              <div class="p-5 pt-0 border-none border-b-0 border-gray-200">
                <div class="text-dark leading-tight">
                  <div class="relative overflow-x-auto mb-3 hidden md:block">
                    <table class="w-full border borer-primary table-auto">
                      <thead class="text-left text-primary">
                        <tr>
                          <th class="p-2 border-gray border">{{ tr('Destino') }}</th>
                          <th class="p-2 border-gray border">{{ tr('Hotel') }}</th>
                          <th class="p-2 border-gray border">{{ tr('Cantidad De Noches') }}</th>
                          <th class="p-2 border-gray border">{{ tr('Tipo De Habitacion') }}</th>
                          <th class="p-2 border-gray border">{{ tr('Check-in Time') }}</th>
                          <th class="p-2 border-gray border">{{ tr('Check-out Time') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(h, i) in hotelPainting" :key="i">
                          <td class="p-2 border-gray border">{{ h?.Destination || '' }}</td>
                          <td class="p-2 border-gray border">{{ tr(h?.Hotel) || '' }}</td>
                          <td class="p-2 border-gray border">{{ h['Number of nights'] || '' }}</td>
                          <td class="p-2 border-gray border">{{ h['Room type'] || '' }}</td>
                          <td class="p-2 border-gray border">{{ h['Check-in Time'] }}</td>
                          <td class="p-2 border-gray border">{{ h['Check-out Time'] }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="block md:hidden">
                    <div v-for="(h, i) in hotelPainting" :key="'m-' + i" class="mb-5 block">
                      <div class="mt-1 px-2 pb-1 mb-1 border-b border-b-black">
                        <h4 class="mb-1 text-sm text-primary font-bold">{{ tr('Destino') }}</h4>
                        <p class="text-sm">{{ h?.Destination || '' }}</p>
                      </div>
                      <div class="mt-1 px-2 pb-1 mb-1 border-b border-b-black">
                        <h4 class="mb-1 text-sm text-primary font-bold">{{ tr('Hotel') }}</h4>
                        <p class="text-sm">{{ tr(h?.Hotel) || '' }}</p>
                      </div>
                      <div class="mt-1 px-2 pb-1 mb-1 border-b border-b-black">
                        <h4 class="mb-1 text-sm text-primary font-bold">{{ tr('Cantidad noches') }}</h4>
                        <p class="text-sm">{{ h['Number of nights'] || '' }}</p>
                      </div>
                      <div class="mt-1 px-2 pb-1 mb-1 border-b border-b-black">
                        <h4 class="mb-1 text-sm text-primary font-bold">{{ tr('Tipo habitacion') }}</h4>
                        <p class="text-sm">{{ h['Room type'] || '' }}</p>
                      </div>
                      <div class="mt-1 px-2 pb-1 mb-1">
                        <h4 class="mb-1 text-sm text-primary font-bold">Check-in / Check out</h4>
                        <p class="text-sm">{{ h['Check-in Time'] }} / {{ h['Check-out Time'] }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <PriceTerms bookingType="GROUPS" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import * as _ from 'lodash';
import PriceTerms from '@/components/itinerary/PriceTerms.vue';

export default {
  name: 'PricingGroup',
  components: {
    PriceTerms,
  },
  props: {
    bookingType: {
      type: String,
      default: 'GROUPS'
    }
  },
  data() {
    return {
      showHotels: false,
    };
  },
  computed: {
    groupPrices() {
      const prices = this.$store.state.groupRoomPrices || [];
      if (this.$route.params.name) return prices;
      return prices.filter((price) => !this.$store.getters.isMainTrip(price.PaxName));
    },
    hotels() {
      return this.$store.state.hotels;
    },
    hotelPainting() {
      return this.$store.getters.groupHotelPainting;
    },
    isQuote() {
      return this.$store.state.fitStatus === 'Quote';
    },
    hidePrices() {
      return this.$store.state.hidePrices;
    },
    currencyRate() {
      return this.$store.state.currencyRate || 1;
    },
    currency() {
      return this.$store.state.currency || 'USD';
    },
    category() {
      if (this.hotels) {
        let rows = _.uniqBy(this.hotels, (r) => r.ClassCode);
        if (rows.length == 1 && rows[0].ClassName != 'Unassigned') {
          return rows[0].ClassName;
        }
      }
      return '';
    },
  },
  methods: {
    getCategoryForPax() {
      return this.category;
    },
    toggleHotels() {
      this.showHotels = !this.showHotels;
    },
    viewHotels() {
      if (this.$route.params.name) {
        const route = this.$router.resolve({
          name: 'GroupHotels',
          params: { name: this.$route.params.name },
          query: this.$route.query,
        });
        window.open(route.href, '_blank');
        return;
      }
      let route = this.$router.resolve({ name: 'Hotels', params: this.$route.query });
      route.href = route.href + '?' + new URLSearchParams({ ...this.$route.query, groups: 'true' }).toString();
      window.open(route.href, '_blank');
    },
    tr(key) {
      return this.$root.tr(key);
    },
  },
};
</script>
